import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Minus, Plus, Check, ArrowRight } from "lucide-react";
import { PillButton } from "../../components/ui/PillButton";
import { StickerCard } from "../../components/ui/StickerCard";
import { SectionHeading } from "../../components/ui/SectionHeading";
import { CloudsLayer } from "../../components/ui/Decorations";
import { TICKET_PACKAGE } from "../../data/mockData";
import { ASSETS } from "../../data/assets";
import { formatIDR } from "../../lib/format";

export default function Tickets() {
  const navigate = useNavigate();
  const [qty, setQty] = useState(1);
  const p = TICKET_PACKAGE;
  const total = qty * p.price;

  return (
    <div className="relative">
      <section className="relative overflow-hidden pt-10 pb-6">
        <CloudsLayer />
        <div className="max-w-6xl mx-auto px-4 text-center relative z-10">
          <SectionHeading eyebrow="Tickets" title="Get Your Family Pass!" subtitle="Satu paket untuk 1 orang tua + 1 anak. Tambah paket untuk anak lainnya." />
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-8 items-start">
          {/* Package card */}
          <StickerCard data-testid="tickets-package">
            <div className="bg-coral text-white text-center py-5">
              <p className="font-display text-2xl">{p.name}</p>
              <p className="text-white/85 font-semibold text-sm">1 Orang Tua + 1 Anak</p>
            </div>
            <div className="p-6">
              <div className="text-center">
                <span className="font-display text-4xl text-sea-deep">{formatIDR(p.price)}</span>
                <span className="text-sea-deep/60 font-bold"> {p.perLabel}</span>
              </div>
              <ul className="mt-5 grid gap-2">
                {p.benefits.map((b) => (
                  <li key={b} className="flex items-start gap-2 text-sm font-semibold text-sea-deep">
                    <span className="mt-0.5 w-5 h-5 rounded-full bg-lime flex items-center justify-center shrink-0">
                      <Check className="w-3.5 h-3.5 text-sea-deep" strokeWidth={3} />
                    </span>
                    {b}
                  </li>
                ))}
              </ul>
              <p className="text-xs text-sea-deep/50 mt-4 font-semibold">*Terms &amp; Conditions apply.</p>
            </div>
          </StickerCard>

          {/* Quantity + checkout */}
          <div className="md:sticky md:top-24 space-y-5">
            <StickerCard className="p-6">
              <h3 className="font-display text-xl text-sea-deep">Jumlah Paket</h3>
              <p className="text-sm text-sea-deep/60 font-semibold">1 paket = 1 orang tua + 1 anak</p>
              <div className="mt-4 flex items-center justify-between bg-sky/15 rounded-2xl p-3">
                <button
                  onClick={() => setQty((q) => Math.max(1, q - 1))}
                  className="w-12 h-12 rounded-full bg-white shadow-playful flex items-center justify-center text-coral disabled:opacity-40"
                  disabled={qty <= 1}
                  data-testid="qty-decrease"
                  aria-label="Kurangi"
                >
                  <Minus className="w-5 h-5" strokeWidth={3} />
                </button>
                <span className="font-display text-3xl text-sea-deep" data-testid="qty-value">{qty}</span>
                <button
                  onClick={() => setQty((q) => Math.min(10, q + 1))}
                  className="w-12 h-12 rounded-full bg-white shadow-playful flex items-center justify-center text-coral"
                  data-testid="qty-increase"
                  aria-label="Tambah"
                >
                  <Plus className="w-5 h-5" strokeWidth={3} />
                </button>
              </div>

              <div className="mt-5 flex items-center justify-between border-t border-slate-100 pt-4">
                <span className="font-bold text-sea-deep/70">Total</span>
                <span className="font-display text-2xl text-coral" data-testid="tickets-total">{formatIDR(total)}</span>
              </div>

              <PillButton
                size="lg"
                className="w-full mt-5"
                onClick={() => navigate("/tickets/checkout", { state: { qty } })}
                data-testid="proceed-checkout"
              >
                Lanjut ke Pembayaran <ArrowRight className="w-5 h-5" />
              </PillButton>
            </StickerCard>

            <div className="flex items-center gap-4 bg-white rounded-3xl p-4 shadow-playful">
              <img src={ASSETS.balapKarung} alt="" className="w-24 h-24 object-contain" />
              <p className="text-sm font-bold text-sea-deep/70">
                Setiap tiket termasuk racepack keren & akses ke semua keseruan family market. Yuk, ajak si kecil!
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
